import React, { Component } from 'react'
import { Card, PageHeader, Button, Row, Col,Modal } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { SpecieProvider } from '../../context/SpecieContext'
import { IntegrationProvider, IntegrationConsumer } from '../../context/IntegrationContext'
import { ShelterConsumer, ShelterProvider } from '../../context/ShelterContext'
import { PartnerKeyTypeArray } from '../../interfaces/IIntegration'
import IntegrationNetworkList from '../../components/IntegrationNetworkList'
import RegisterNetworkForm from '../../components/Forms/Network/Register'
import NetworkForm from '../../components/Forms/Network'
import debounce from 'lodash.debounce'

export default class Integration extends Component {

  state = {
    openedModal: false,
    selectedItem: null
  }

  private listRef = React.createRef<IntegrationNetworkList>()

  private integrationFilterDispatchOptions = {
    search: {
      deleted: false,
      shelter: {
        with: true
      }
    },
    options: {
    }
  } as const

  integrationListSearch = Object.assign({}, this.integrationFilterDispatchOptions)

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.integrationListSearch = {
        ...this.integrationListSearch,
        search: payload.search
      }
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Button type="primary" shape="round" onClick={() => {
        this.setState({openedModal:true})
      }}>
        Create new network
      </Button>
    )
  }

  handleModalClose = () => {
    this.setState({selectedItem : null,openedModal:false});
    //history.replace(`/integration-mapping/${activeTab}`)
    this.listRef.current?.load();

    
  }

  editItem(item){
    this.setState({selectedItem : item,openedModal:true});
  }

  render() {
    const { permissions, history, match: { params: { integrationUuid } } }: any = this.props


    return (
      <IntegrationProvider>
        <SpecieProvider>
          <ShelterProvider>
            <ShelterConsumer>
              {({ shelters, requestShelterList }) => (
                <IntegrationConsumer>
                  {({
                    fetching,
                    error,
                    integrations,
                    integration,
                    authUuid,
                    settings,
                    total,
                    sync,
                    syncSections,
                    pagination,
                    requestNetworkFind,
                    requestIntegrationNetworkCreate,
                    requestIntegrationNetworkUpdate,
                    requestIntegrationNetworkList,
                    requestVerifyNetworkSettings,
                    requestVerifySync,
                    requestVerifySyncSections,
                    requestRetrieveTotalPet,
                    requestSyncOne,
                    requestSyncAbort,
                    requestUpdateSettings,
                    requestUpdateSyncSections,
                    requestConnect,
                    requestDisconnect,
                    requestSetMain,
                  }) => {
                    // Shelter filters
                    const loadSheltersDispatch = (args: any = {}) => requestShelterList({
                      search: {
                        ...args,
                        organization_branches: {
                          with: true
                        }
                      },
                      options: {
                        limit:-1,
                        sort: [
                          '-organization_branches.name'
                        ],
                        _force_ids: true
                      }
                    })
                    
                    const delayedSearch = debounce((v) => {
                      if (v) {
                        loadSheltersDispatch({ name: { ilike: `%${v}%` } });
                      }
                    }, 500);

                    const sheltersToFilter = shelters?.map(v => {
                      return {
                        value: v.id,
                        text: v.name
                      }
                    })

                    const partnerToFilter = PartnerKeyTypeArray.map(v => {
                      return {
                        value: v,
                        text: v
                      }
                    })

                    

                    // Edit integration
                    if (integrationUuid) {
      
                      let addon: any = {
                        integrationUuid: integrationUuid,
                        permissions: permissions
                      }

                      const network = (integration as any)?.result ? (integration as any)?.result[0] : null;

      
                      return (
                        <Card>
                          <PageHeader title={integration ? `Network - ${network?.shelter?.name}/${network?.partner_key}` : 'Loading'} onBack={() => history.replace('/network')}>
                            <NetworkForm
                              {...addon}
      
                              integration={integration}
                              settings={settings}
                              total={total}
                              sync={sync}
                              syncSections={syncSections}
      
                              loading={fetching}
                              error={error}
                              history={history}
      
                              loadIntegration={requestNetworkFind}
                              verifySettings={requestVerifyNetworkSettings}
                              verifySync={requestVerifySync}
                              verifySyncSections={requestVerifySyncSections}
      
                              retrieveTotalPet={requestRetrieveTotalPet}
      
                              syncOne={requestSyncOne}
                              syncAbort={requestSyncAbort}
      
                              updateSettings={requestUpdateSettings}
                              updateSyncSections={requestUpdateSyncSections}
                            />
                            
                          </PageHeader>
                        </Card>
                      )
                    }
      
                    return (
                      <>
                        <Card title="Filters" style={{ marginBottom: 25 }}>
                          <Filters size="medium" loading={fetching} history={history} defaultSubmitOptions={this.integrationFilterDispatchOptions} dispatches={[loadSheltersDispatch]} submitDispatch={requestIntegrationNetworkList} onSubmit={this.handleFiltersSubmit}>
                            {({ values, handleFilterChange }: any) => (
                              <Row gutter={9} style={{ width: '100%' }}>
                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="uuid"
                                    type={Types.INPUT}
                                    placeholder="Filter by UUID"
                                    value={values['uuid']}
                                    size="medium"
                                    options={{
                                      input: {
                                        allowClear: true
                                      }
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>
      
                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="shelter_id"
                                    type={Types.SELECT}
                                    placeholder="Shelter"
                                    data={sheltersToFilter}
                                    value={values['shelter_id']}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true,
                                        onDropdownVisibleChange: (open) => {
                                          if (open) {
                                            loadSheltersDispatch();
                                          }
                                        },
                                        onSearch: async (v) => {
                                          delayedSearch(v);
                                        },
                                      }
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>

                                <Col xs={24} md={6}>
                                  <FilterItem
                                    name="partner_key"
                                    type={Types.SELECT}
                                    placeholder="Partner"
                                    data={partnerToFilter}
                                    value={values['partner_key']}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true
                                      }
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Filters>
                        </Card>

                        <Modal
                          title={this.state.selectedItem ? "Update Network" : "New Network"}
                          visible={this.state.openedModal}
                          footer={null}
                          destroyOnClose={true}
                          onCancel={() => this.handleModalClose()}
                        >
                          {
                            // We should re-render the form, because our form trash need to be cleared
                            <RegisterNetworkForm
                              authUuid={authUuid}
                              integration={integration}
                              settings={settings}
                              total={total}
                              error={error}
        
                              loading={fetching || false}
                              history={history}
    
                              verifySettings={requestVerifyNetworkSettings}
                              updateSettings={requestUpdateSettings}
    
                              retrieveTotalPet={requestRetrieveTotalPet}
    
                              authPartner={requestIntegrationNetworkCreate}
                              updateNetwork={requestIntegrationNetworkUpdate}
    
                              makeConnection={requestConnect}

                              closeModal={this.handleModalClose}
                              selectedItem={this.state.selectedItem}
                            />
                          }
                        </Modal>
      
                        <Card title="List of Networks" extra={this.renderAdd()}>
                          <IntegrationNetworkList
                            ref={this.listRef}
                            loading={fetching}
                            integrations={integrations}
                            pagination={pagination}
                            permissions={permissions}
                            history={history}
                            searchOptions={this.integrationListSearch}
                            loadIntegrations={requestIntegrationNetworkList}
                            disconnectIntegration={requestDisconnect}
                            setMainIntegration={requestSetMain}
                            editItem={this.editItem.bind(this)}
                          />
                        </Card>
                      </>
                    )
                  }}
                </IntegrationConsumer>
              )}
            </ShelterConsumer>
          </ShelterProvider>
        </SpecieProvider>
      </IntegrationProvider>
    )
  }
}
